import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";

type EmployeeProfilesTableActionsCellProps = {
    profile: ProfileDto;
    onEdit: (profile: ProfileDto) => void;
    onDelete: (profile: ProfileDto) => void;
};

export const EmployeeProfilesTableActionsCell = ({
    profile,
    onEdit,
    onDelete,
}: EmployeeProfilesTableActionsCellProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            alignItems="center"
            gap="4px"
            margin="0 4px"
            justifyContent="space-between"
        >
            <Box flex="1">
                <Tooltip content={translate("si.common.edit")}>
                    <IconButton
                        type="flat"
                        iconName="edit-icon-fill"
                        iconSize="xs"
                        onClick={() => onEdit(profile)}
                        dataAutomation="employee-profiles-edit"
                    />
                </Tooltip>
            </Box>
            <Box flex="1">
                <Tooltip content={translate("si.common.button.delete")}>
                    <IconButton
                        type="flat"
                        iconName="delete"
                        iconSize="xs"
                        onClick={() => onDelete(profile)}
                        dataAutomation="employee-profiles-delete"
                    />
                </Tooltip>
            </Box>
        </Flex>
    );
};
